import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';

const CsatProgress = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const completeReturn = async () => {
      const cancelled = new URLSearchParams(location.search).get('status') === 'cancel';
      try {
        const endpoint = cancelled ? '/csat/dismiss' : '/csat/';
        const { data } = await axios.post(`${process.env.REACT_APP_API_URL}${endpoint}`);
        // Older servers return HTTP 200 even when the write failed.
        if (data.success === false || (data.success !== true && data.message !== 'success')) {
          throw new Error(data.message || 'ไม่สามารถบันทึกสถานะการประเมินได้');
        }
        await Swal.fire({
          title: cancelled ? 'ยกเลิกการประเมิน' : 'สำเร็จ!',
          text: cancelled ? 'คุณได้ยกเลิกการประเมินแล้ว' : 'บันทึกสถานะการประเมินเรียบร้อยแล้ว',
          icon: cancelled ? 'info' : 'success',
          confirmButtonText: 'ตกลง',
        });
        navigate('/invoice-main', { replace: true });
      } catch (error) {
        const result = await Swal.fire({
          title: 'บันทึกสถานะการประเมินไม่สำเร็จ',
          text: error.message,
          icon: 'error',
          confirmButtonText: 'ลองอีกครั้ง',
          showCancelButton: true,
          cancelButtonText: 'กลับหน้ารายการ',
        });
        if (result.isConfirmed) {
          await completeReturn();
        } else {
          navigate('/invoice-main', { replace: true });
        }
      }
    };

    completeReturn();
  }, [navigate, location.search]);

  return null;
};

export default CsatProgress;
